import { Component } from '@angular/core';
import { ApplyButtonComponent } from '../../../shared/components/apply-button/apply-button.component';

@Component({
  selector: 'app-commitment-section',
  standalone: true,
  imports: [ApplyButtonComponent],
  templateUrl: './commitment-section.component.html',
  styleUrls: ['./commitment-section.component.scss']
})
export class CommitmentSectionComponent {} 